import { lazy } from 'react'
import type { RouteObject } from 'react-router-dom'

const FrameworkEngineLayout = lazy(() =>
  import('../components/framework-engine/FrameworkEngineLayout').then((m) => ({ default: m.FrameworkEngineLayout }))
)
const FrameworkPortfolioPage = lazy(() =>
  import('../pages/framework-engine').then((m) => ({ default: m.FrameworkPortfolioPage }))
)
const FrameworkCatalogPage = lazy(() =>
  import('../pages/framework-engine').then((m) => ({ default: m.FrameworkCatalogPage }))
)
const FrameworkCatalogDetailPage = lazy(() =>
  import('../pages/framework-engine').then((m) => ({ default: m.FrameworkCatalogDetailPage }))
)
const FrameworkAdoptionWizard = lazy(() =>
  import('../pages/framework-engine').then((m) => ({ default: m.FrameworkAdoptionWizard }))
)
const FrameworkUpdateManager = lazy(() =>
  import('../pages/framework-engine').then((m) => ({ default: m.FrameworkUpdateManager }))
)
const FrameworkRespondPage = lazy(() =>
  import('../pages/framework-engine').then((m) => ({ default: m.FrameworkRespondPage }))
)
const FrameworkTemplateLibraryPage = lazy(() =>
  import('../pages/framework-engine').then((m) => ({ default: m.FrameworkTemplateLibraryPage }))
)
const TemplateDetailPage = lazy(() =>
  import('../pages/framework-engine').then((m) => ({ default: m.TemplateDetailPage }))
)
const ImplementationGuidePage = lazy(() =>
  import('../pages/framework-engine').then((m) => ({ default: m.ImplementationGuidePage }))
)
const DocumentInstancesPage = lazy(() =>
  import('../pages/framework-engine').then((m) => ({ default: m.DocumentInstancesPage }))
)

export const frameworkEngineRoutes: RouteObject[] = [
  {
    path: '/framework-engine',
    element: <FrameworkEngineLayout />,
    children: [
      { index: true, element: <FrameworkPortfolioPage /> },
      { path: 'catalog', element: <FrameworkCatalogPage /> },
      // Framework detail view (card click) + start-adoption entrypoint (Adopter).
      { path: 'catalog/:frameworkId', element: <FrameworkCatalogDetailPage /> },
      { path: 'adopt/:frameworkId', element: <FrameworkAdoptionWizard /> },
      { path: 'wizard', element: <FrameworkAdoptionWizard /> },
      { path: 'wizard/:implementationId', element: <FrameworkAdoptionWizard /> },
      { path: 'respond', element: <FrameworkRespondPage /> },
      { path: 'updates', element: <FrameworkUpdateManager /> },
      // Template & document pages
      { path: 'templates', element: <FrameworkTemplateLibraryPage /> },
      { path: 'templates/:templateId', element: <TemplateDetailPage /> },
      { path: 'implementation-guide/:frameworkId', element: <ImplementationGuidePage /> },
      { path: 'documents', element: <DocumentInstancesPage /> },
    ],
  },
]
